import { render, staticRenderFns } from "./LocalPalletsAdd.vue?vue&type=template&id=41ee5e60&scoped=true"
import script from "./LocalPalletsAdd.vue?vue&type=script&lang=js"
export * from "./LocalPalletsAdd.vue?vue&type=script&lang=js"
import style0 from "./LocalPalletsAdd.vue?vue&type=style&index=0&id=41ee5e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ee5e60",
  null
  
)

export default component.exports